import React, { useMemo } from "react";
import { useTranslation } from "@opendash/core";
import { ParseSetView } from "@opendash/plugin-parse";
import { TableViewType } from "@opendash/plugin-parse/dist/types";
import { ColumnProps } from "antd/lib/table";

const KauflandClass = "HG_Kaufland";

export default function KauflandMeta() {
  const t = useTranslation();

  return (
    <ParseSetView
      className={KauflandClass}
      view={
        {
          type: "table",

          fields: ["machine", "store_no", "order_code"],
        } as TableViewType
      }
    />
  );
}
